class SizeGuideModal extends HTMLElement {
  constructor() {
    super();
    this.dialogModal = document.querySelector("#sizeguide__dialog");
    this.closeButton = this.querySelector("#sizeguide__close");
    this.typeButtons = this.querySelectorAll(
      'input[name="sizeguide__typeButton"]',
    );
    this.unitButtons = this.querySelectorAll(
      'input[name="sizeguide__unitButton"]',
    );
    this.sizeguide__tables = this.querySelectorAll(".sizeguide__table");
    this.sizeguide__diagrams = this.querySelectorAll(".sizeguide__diagram");
    this.measurements = this.querySelectorAll(".sizeguide__measurement");

    this.addEventListener("click", (e) => {
      const close = e.target.closest("#sizeguide__close,view-in-room-trigger");
      console.log(`close`, close);
      if (close) {
        this.handleClose();
      }
    });
  }
  // Element functionality written in here
  connectedCallback() {
    /* Open Modal */

    const openModal = () => {
      this.dialogModal.showModal();
    };
    document.addEventListener("openSizeGuideModal", openModal);

    /* Recieve Variant Change event - Change Modal on variant select (Print or Framed) */
    const handleVariantChangeEvent = (event) => {
      this.typeButtons.forEach((element) => {
        if (event.detail.value === element.value) {
          element.checked = true;
        }
      });

      handleTypeToggle(event.detail.value);
    };

    document.addEventListener("setSizeGuideModal", handleVariantChangeEvent);

    /* Close Modal */
    // this.closeButton.addEventListener('click', this.handleClose.bind(this));

    /* Product Type Toggle (Framed or Print) */
    const handleTypeToggle = (value) => {
      this.sizeguide__tables.forEach((element) => {
        if (element.dataset.productType === value) {
          element.hidden = false;
          return;
        }
        element.hidden = true;
      });

      this.sizeguide__diagrams.forEach((element) => {
        if (element.dataset.productType === value) {
          element.hidden = false;
          return;
        }
        element.hidden = true;
      });
    };

    this.typeButtons.forEach((radio) => {
      radio.addEventListener("change", function () {
        handleTypeToggle(this.value);
      });
    });

    /* Unit toggle (IN or CM)*/
    const handleUnitToggle = (value) => {
      this.measurements.forEach((element) => {
        if (element.dataset.unit === value) {
          element.hidden = false;
          return;
        }
        element.hidden = true;
      });
    };

    this.unitButtons.forEach((radio) => {
      radio.addEventListener("change", function () {
        handleUnitToggle(this.value);
      });
    });
  }

  /* Close Modal */
  handleClose() {
    this.dialogModal.close();
  }
}

class SizeGuideTrigger extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector("#sizeguide__toggle");
  }
  connectedCallback() {
    const openSizeGuideModal = new CustomEvent("openSizeGuideModal");
    this.trigger.addEventListener("click", function (e) {
      e.preventDefault();
      document.dispatchEvent(openSizeGuideModal);
    });
  }
}
if (!customElements.get("size-guide-modal")) {
  customElements.define("size-guide-modal", SizeGuideModal);
}
if (!customElements.get("size-guide-trigger")) {
  customElements.define("size-guide-trigger", SizeGuideTrigger);
}
